/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as l from "react";
import { TableSelection as r } from "@progress/kendo-react-data-tools";
import { GridContext as n } from "../../GridClientWrapper.mjs";
const o = (t) => {
  const e = l.useContext(n);
  return /* @__PURE__ */ l.createElement(
    r,
    {
      selectable: t.selectable,
      onRelease: e.selectionRelease,
      childRef: (a) => {
        e.tableElementRef.current = a, e.headTableElementRef.current = a;
      }
    },
    /* @__PURE__ */ l.createElement("table", { ref: e.headTableElementRef, className: t.tableClassName }, t.children)
  );
};
export {
  o as GridTable
};
